<script setup lang="ts">
import "@maersk-global/mds-components-core/mc-modal";
import "@maersk-global/mds-components-core/mc-button";
import { type ModalButton, ModalEvent, Emits } from ".";

const emit = defineEmits<Emits>();

defineProps<{
  isOpen: boolean;
  heading: string;
  height?: string;
  buttons: ModalButton[];
}>();

const onClose = (event: ModalEvent) => {
  emit("close", event.detail.action);
};

const onClick = (button: ModalButton) => {
  emit("click", button.value);
};
</script>

<template>
  <mc-modal
    data-test="modal"
    :open="isOpen"
    fit="small"
    :heading="heading"
    :height="height"
    @closed.prevent.stop="onClose"
  >
    <slot name="body"></slot>
    <mc-button
      v-for="button of buttons"
      :key="button.value"
      :slot="button.primary ? 'primaryAction' : 'secondaryAction'"
      :data-test="`modal/button-${button.value}`"
      :label="button.label"
      :dialogaction="button.value"
      :appearance="button.primary ? 'primary' : 'neutral'"
      fit="medium"
      :disabled="button.disabled"
      @click.prevent.stop="onClick(button)"
    ></mc-button>
  </mc-modal>
</template>
